<template>
  <div class="teachingActivity">
    <div class="title">投票分布情况</div>
    <div class="VotingMap" ref="votingECharts"></div>
    <div class="vote_status">投票状态: <span :class="['button',{'active_button':activeStatus==1}]" @click="changeStatus(1)">全部</span> <span :class="['button',{'active_button':activeStatus==2}]" @click="changeStatus(2)">只看未提交学生</span></div>
    <el-table :data="student_detailData.slice((pageParams.page-1)*pageParams.size,pageParams.page*pageParams.size)" style="width: 100%" :header-cell-style="{fontWeight: 'normal', color: '#333', background: '#f5f7fa',}" class="table-content"
      :cell-style="{fontSize: '12px',color: '#333'}">
      <el-table-column prop="student_name" label="学生名称">
      </el-table-column>
      <el-table-column prop="status" label="提交状态">
        <template slot-scope="scope">
          <span :style="{color:scope.row.status?'':'red'}"> {{ scope.row.status?'已提交':'未提交' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="vote_option" label="投票结果" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          {{  scope.row.vote_option?scope.row.vote_option:"-"}}
        </template>
      </el-table-column>
      <el-table-column prop="create_time" label="投票时间">
        <template slot-scope="scope">
          {{  scope.row.create_time?scope.row.create_time:"-"}}
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination background @current-change="handleCurrentChangeData" :current-page.sync="pageParams.page" :page-size="pageParams.size" layout="prev, pager, next" :total="pageParams.total">
      </el-pagination>
    </div>
  </div>
</template>
    
    <script>
export default {
  name: "teacherTextbook",
  components: {},
  data() {
    return {
      query: {},
      options_stats: [],
      student_details: [],
      student_detailData: [],
      activeStatus: 1,
      pageParams: {
        page: 1,
        size: 10,
        total: 0,
      },
    };
  },
  created() {
    this.query = JSON.parse(localStorage.getItem("query"));
    this.getVoteDetial();
  },

  methods: {
    getVoteDetial() {
      this.$shttp.axiosPost(
        this.$api.jdTActivitiesVoteInfo,
        { id: this.query.id },
        (res) => {
          if (res.code === 200) {
            this.options_stats = res.data.options_stats;
            this.student_details = res.data.student_details;
            this.student_detailData = res.data.student_details;
            this.pageParams.total = res.data.total_students;
            let xData = this.options_stats.map((item) => item.option_text);
            let yData = this.options_stats.map((item) => item.vote_count);

            this.getEcharts(xData, yData);
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },
    getEcharts(xData, yData) {
      const max = Math.max(...yData);
      var chart = this.$echarts.init(this.$refs.votingECharts);
      var baseColors = [
        "#4c7eff",
        "#50D39C",
        "#526486",
        "#31CFCF",
        "#6BBB25",
        "#FF161A",
        "#7077BD",
        "#F2BD21",
        "#E26D52",
        "#FF4B27",
        "#D8D8D8",
      ];
      var colors = [];
      // 动态扩展颜色数组
      while (colors.length < yData.length) {
        colors = colors.concat(baseColors);
      }
      colors = colors.slice(0, yData.length);

      let option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
          formatter: function (params) {
            var result = params[0].name + "<br/>";
            for (var i = 0; i < params.length; i++) {
              result += "人数" + ": " + params[i].value + " 人<br/>";
            }
            return result;
          },
        },
        xAxis: {
          type: "category",
          data: xData,
          axisLabel: {
            // 文字超出宽度时截断显示并显示省略号
            overflow: "truncate",
            // 自定义格式化函数，可根据需求设置截取长度
            formatter: function (value) {
              if (value.length > 8) {
                return value.slice(0, 4) + "...";
              }
              return value;
            },
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            lineStyle: {
              color: "#7C7D84", // 设置 X 轴的颜色为红色
            },
          },
        },
        grid: {
          left: "4%",
          right: "4%",
        },
        yAxis: {
          type: "value",
          name: "人数数值",
          axisTick: {
            show: false,
          },
          axisLabel: {
            formatter: function (value) {
              return Math.round(value); // 四舍五入取整
            },
          },
          // 可选：手动控制刻度范围和间隔
          min: 0,
          max: Math.ceil((this.pageParams.total - 1) / 10) * 10,

          axisLine: {
            lineStyle: {
              color: "#7C7D84", // 设置 X 轴的颜色为红色
            },
            show: false,
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: "#E0E6F1", // 设置网格线颜色为绿色
              type: "dotted", // 设置网格线样式为点状线
            },
          },
        },
        series: [
          {
            data: yData,
            type: "bar",
            barWidth: 20,
            barGap: "10%",
            itemStyle: {
              // 使用扩展后的颜色数组
              color: function (params) {
                return colors[params.dataIndex];
              },
            },
          },
        ],
      };
      chart.setOption(option);
    },
    changeStatus(type) {
      this.activeStatus = type;
      if (type == 1) {
        this.student_detailData = this.student_details;
      } else {
        this.student_detailData = this.student_details.filter(
          (item) => !item.status
        );
      }
    },
    handleCurrentChangeData(val) {
      this.pageParams.page = val;
    },
  },
};
</script>
    
    <style scoped lang="scss">
.teachingActivity {
  width: 100%;
  height: 100%;
  .title {
    margin-bottom: 10px;
  }
  .VotingMap {
    width: 100%;
    height: 350px;
    background: #ffffff;
    border-radius: 4px 4px 4px 4px;
    border: 1px solid #f2f2f4;
  }
  .vote_status {
    height: 50px;
    display: flex;
    align-items: center;
    .button {
      display: inline-block;
      padding: 5px 10px;
      margin: 0 10px;
      background: #f9f9f9;
      border-radius: 4px 4px 4px 4px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #666666;
      line-height: 16px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      cursor: pointer;
    }
    .active_button {
      background: rgba(0, 110, 255, 0.1);
      border-radius: 4px 4px 4px 4px;
      font-size: 14px;
      color: #006eff;
    }
  }
  .table-content {
    background: #ffffff;
    border-radius: 4px 4px 4px 4px;
    border: 1px solid #dcdcdc;
  }
  .pagination {
    width: 100%;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>